const routes = {
    path: 'pessoa/parceiro',
    name: 'MapaParceiros_Parceiro',
    component: () => import('./lista/ListaParceiros.vue'),
    meta: {
        rules: ['MAPAPARC-PES-00'],
    },
};

export default routes;